import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from './locales/en-us.json'
import zhCN from './locales/zh-cn.json'
 
Vue.use(VueI18n)
 
const messages = {
  'en-us': enUS,
  'zh-cn': zhCN
}
 
// 获取浏览器语言设置
const navigatorLang = navigator.language || 'zh-cn'
const defaultLang = Object.keys(messages).includes(navigatorLang) 
  ? navigatorLang 
  : 'zh-cn'
 
// 创建 i18n 实例
const i18n = new VueI18n({
  locale: localStorage.getItem('cur_language') || defaultLang,
  fallbackLocale: 'zh-cn',
  messages
})
 
export default i18n